/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Success(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 25.01 25.01'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>success</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#EFEFEF'}
                        id='Layer_1-2'
                    >
                        <path d='M12.5,25A12.51,12.51,0,1,1,25,12.5,12.52,12.52,0,0,1,12.5,25Zm0-24A11.5,11.5,0,1,0,24,12.5,11.51,11.51,0,0,0,12.5,1Z' />
                        <path d='M11.28,16h0a.5.5,0,0,1-.36-.16C9.42,14.26,7.14,11.81,7,11.67s-.35-.49,0-.79a.53.53,0,0,1,.67,0c.15.15,3.66,3.89,3.65,3.89l6-5.7a.51.51,0,0,1,.72,0,.52.52,0,0,1,0,.72l-6.33,6.05A.5.5,0,0,1,11.28,16ZM7.69,11.66h0Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}